import { render, staticRenderFns } from "./NotationModal.vue?vue&type=template&id=3b51d5f0&scoped=true&"
import script from "./NotationModal.vue?vue&type=script&lang=js&"
export * from "./NotationModal.vue?vue&type=script&lang=js&"
import style0 from "./NotationModal.vue?vue&type=style&index=0&id=3b51d5f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b51d5f0",
  null
  
)

export default component.exports